import { memo, useCallback, useState } from 'react'
import { SmartGridDrawer } from './SmartGridDrawer.js'
import { useActiveGrid, useActiveChannelId, useAgendaView } from '../../store/index.js'
import { ensureWeeklyGrid } from '../../lib/ensureWeeklyGrid.js'

export const SmartGridButton = memo(function SmartGridButton(props: { onApplied?: () => void; compact?: boolean; disabled?: boolean }) {
  const [open, setOpen] = useState(false)
  const [gridId, setGridId] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const activeGrid      = useActiveGrid()
  const channelId       = useActiveChannelId()
  const agendaView      = useAgendaView()

  const handleOpen = useCallback(async () => {
    if (props.disabled) return
    if (!channelId) return
    setLoading(true)
    setError(null)
    try {
      const grid = activeGrid ?? await ensureWeeklyGrid(channelId, agendaView.date)
      setGridId(grid.id)
      setOpen(true)
    } catch (cause: any) {
      setError(cause?.message ?? 'Impossible de préparer la grille de cette semaine.')
    } finally {
      setLoading(false)
    }
  }, [activeGrid, agendaView.date, channelId, props.disabled])
  const handleClose = useCallback(() => setOpen(false), [])

  if (!channelId) return null

  const title = props.disabled ? 'Permission GRID_AI_MANAGE requise' : error ?? 'Remplir la semaine affichée avec la grille intelligente'

  return (
    <>
      <button
        onClick={handleOpen}
        disabled={loading || props.disabled}
        title={title}
        aria-label={title}
        className={props.compact
          ? 'tp-icon-button agenda-toolbar__icon agenda-smart-grid-button'
          : 'tp-button agenda-smart-grid-button'}
        data-loading={loading || undefined}
      >
        <SparkleIcon />
        {!props.compact && (loading ? 'Préparation…' : 'Grille intelligente')}
      </button>

      {open && gridId && (
        <SmartGridDrawer
          gridId={gridId}
          channelId={channelId}
          date={agendaView.date}
          onApplied={props.onApplied}
          onClose={handleClose}
        />
      )}
    </>
  )
})

const SparkleIcon = memo(function SparkleIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
      <path
        d="M6.5 1L7.5 5H11.5L8.5 7.5L9.5 11.5L6.5 9L3.5 11.5L4.5 7.5L1.5 5H5.5L6.5 1Z"
        fill="var(--color-brand)" stroke="var(--color-brand)" strokeWidth="0.5" strokeLinejoin="round"
      />
    </svg>
  )
})
